/* ==========================================================================
   TIIAN V2 — Parcely térkép marker-klaszterezés (teljesítmény-javítás)
   Kis zoom-szinten a csomagpont-markereket rácsalapon csoportosítja, és
   egy darab számozott klaszter-markert rajzol helyettük. Nagy zoomon
   (SHOW_ALL_ZOOM felett) minden pont egyenként látszik. A klaszterre
   kattintva a térkép ráközelít.
   Nem igényel Leaflet plugint: a Parcely által létrehozott térképpéldányt
   egy L.Map init-hookkal kapjuk el, a markereket az addLayer/removeLayer
   átcsomagolásával követjük.
   ========================================================================== */

(function () {
  'use strict';

  var GRID_PX = 80; /* klaszter-rács mérete pixelben */
  var SHOW_ALL_ZOOM = 25; /* ettől a zoomtól minden marker egyenként látszik */
  var hooked = false;

  function isParcelyMap(container) {
    if (!container) return false;
    if (container.classList && container.classList.contains('parcely_map')) return true;
    if (container.closest && container.closest('#parcelyWidgetModal')) return true;
    return false;
  }

  function initClustering(map) {
    if (map.__tiianClusters) return;
    map.__tiianClusters = true;

    var L = window.L;
    var markers = [];
    var clusterLayers = [];
    var rafId = null;

    var origAddLayer = map.addLayer;
    var origRemoveLayer = map.removeLayer;

    function schedule() {
      if (rafId) return;
      rafId = window.requestAnimationFrame(recluster);
    }

    function register(marker) {
      if (marker.__tiianCluster) return;
      if (markers.indexOf(marker) === -1) {
        markers.push(marker);
        schedule();
      }
    }

    function collect(layer) {
      if (layer instanceof L.Marker) register(layer);
      else if (layer && typeof layer.eachLayer === 'function') layer.eachLayer(collect);
    }

    function unregister(layer) {
      if (layer instanceof L.Marker) {
        var index = markers.indexOf(layer);
        if (index > -1) {
          markers.splice(index, 1);
          schedule();
        }
      } else if (layer && typeof layer.eachLayer === 'function') {
        layer.eachLayer(unregister);
      }
    }

    map.addLayer = function (layer) {
      var result = origAddLayer.call(map, layer);
      collect(layer);
      return result;
    };

    map.removeLayer = function (layer) {
      if (!layer || !layer.__tiianCluster) unregister(layer);
      return origRemoveLayer.call(map, layer);
    };

    function clearClusters() {
      for (var i = 0; i < clusterLayers.length; i++) {
        origRemoveLayer.call(map, clusterLayers[i]);
      }
      clusterLayers = [];
    }

    function recluster() {
      rafId = null;
      clearClusters();
      if (!markers.length || !map._loaded) return;

      var zoom = map.getZoom();

      /* Nagy zoom: minden pont egyenként */
      if (zoom >= SHOW_ALL_ZOOM) {
        for (var i = 0; i < markers.length; i++) {
          if (!markers[i]._map) origAddLayer.call(map, markers[i]);
        }
        return;
      }

      /* Rács-alapú csoportosítás pixel-térben (viewport-független,
         így pan közben nem kell újraszámolni, csak zoomkor) */
      var cells = Object.create(null);
      markers.forEach(function (marker) {
        var point = map.project(marker.getLatLng(), zoom);
        var key = Math.floor(point.x / GRID_PX) + ':' + Math.floor(point.y / GRID_PX);
        (cells[key] = cells[key] || []).push(marker);
      });

      Object.keys(cells).forEach(function (key) {
        var group = cells[key];
        if (group.length === 1) {
          if (!group[0]._map) origAddLayer.call(map, group[0]);
          return;
        }

        var latSum = 0;
        var lngSum = 0;
        group.forEach(function (marker) {
          if (marker._map) origRemoveLayer.call(map, marker);
          var latLng = marker.getLatLng();
          latSum += latLng.lat;
          lngSum += latLng.lng;
        });

        var center = L.latLng(latSum / group.length, lngSum / group.length);
        var size = group.length >= 100 ? 'large' : group.length >= 10 ? 'medium' : 'small';
        var cluster = L.marker(center, {
          icon: L.divIcon({
            html: '<span>' + group.length + '</span>',
            className: 'tiian-cluster tiian-cluster--' + size,
            iconSize: [44, 44],
            iconAnchor: [22, 22],
          }),
          keyboard: false,
        });
        cluster.__tiianCluster = true;
        cluster.on('click', function () {
          map.setView(center, Math.min(map.getZoom() + 2, SHOW_ALL_ZOOM));
        });
        origAddLayer.call(map, cluster);
        clusterLayers.push(cluster);
      });
    }

    /* A már fent lévő markereket is be kell gyűjteni: gyorsítótárazott adatnál
       a Parcely szinkronban adja hozzá őket, még a fenti wrapper telepítése
       előtt. Enélkül a modal második megnyitásakor a `markers` tömb üres marad,
       és a `recluster()` azonnal kilép — ez okozta, hogy másodszorra eltűntek
       a klaszterek. */
    map.eachLayer(collect);

    map.on('zoomend', schedule);
    map.whenReady(schedule);
    schedule();
  }

  function tryHook() {
    if (hooked) return true;
    var L = window.L;
    if (!L || !L.Map || typeof L.Map.addInitHook !== 'function') return false;
    hooked = true;
    L.Map.addInitHook(function () {
      var map = this;
      /* Először szinkronban próbálkozunk, hogy a wrapper még a Parcely
         marker-feltöltése előtt a helyén legyen; ha a konténer ilyenkor még
         nem azonosítható, egy tick múlva újrapróbáljuk. */
      if (isParcelyMap(map._container)) {
        initClustering(map);
        return;
      }
      window.setTimeout(function () {
        if (isParcelyMap(map._container)) initClustering(map);
      }, 0);
    });
    return true;
  }

  /* A Parcely (és vele a Leaflet) az app embed miatt bármikor betöltődhet,
     ezért olcsó property-ellenőrzéssel pollozunk, amíg meg nem jelenik. */
  if (!tryHook()) {
    var poll = window.setInterval(function () {
      if (tryHook()) window.clearInterval(poll);
    }, 300);
  }
})();
